export const SEND_FORM = 'SEND_FORM';
export const SET_FIELD_SUM = 'SET_FIELD_SUM';
export const SET_FIELD_OUTPUT_ACCOUNTS_TYPE = 'SET_FIELD_OUTPUT_ACCOUNTS_TYPE';
export const SET_FIELD_ACCOUNT_NUMBER = 'SET_FIELD_ACCOUNT_NUMBER';
export const SET_FIELD_BANK_KEY = 'SET_FIELD_BANK_KEY';
export const SET_FIELD_MEMO_TAG = 'SET_FIELD_MEMO_TAG';

export const SET_COMMISSION = 'SET_COMMISSION';

export const SET_RESULT_OBJECT = 'SET_RESULT_OBJECT';
export const INIT_STATE = 'INIT_STATE';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/actionsTypes.js